/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Job, JobInterface } from "../Job";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_initialToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_daoTreasury",
        type: "address",
      },
      {
        internalType: "address",
        name: "_resolver",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payoutAmount",
        type: "uint256",
      },
    ],
    name: "JobApproved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobClosedByEngineer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobClosedBySupplier",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "reporter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "JobDelisted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "engineerAmountPct",
        type: "uint256",
      },
    ],
    name: "JobDisputeResolved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobDisputed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "JobPosted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "reporter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "JobReportDeclined",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "reporter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "JobReported",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "engineer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "JobStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payoutAmount",
        type: "uint256",
      },
    ],
    name: "JobTimeoutPayout",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "value",
        type: "bool",
      },
    ],
    name: "PaymentTokensUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "COMPLETED_TIMEOUT_SECONDS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DAO_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINIMUM_BOUNTY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINIMUM_DEPOSIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REPORT_DEPOSIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REPORT_REWARD_PERCENT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REPORT_TOKEN",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RESOLUTION_FEE_PERCENTAGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "acceptReport",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "approveJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "cancelJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "closeJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "completeJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "completeTimedOutJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "daoTreasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "declineReport",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "disputeJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "disputeResolver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllPaymentTokens",
    outputs: [
      {
        internalType: "contract IERC20[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "getDisputePayouts",
    outputs: [
      {
        internalType: "uint256",
        name: "forWinner",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forDao",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "getJobPayouts",
    outputs: [
      {
        internalType: "uint256",
        name: "forEngineer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forEngineerNoDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forDao",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "jobCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "jobs",
    outputs: [
      {
        internalType: "bool",
        name: "closedBySupplier",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "closedByEngineer",
        type: "bool",
      },
      {
        internalType: "enum Job.States",
        name: "state",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "supplier",
        type: "address",
      },
      {
        internalType: "address",
        name: "engineer",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "requiredDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bounty",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "completedTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    name: "paymentTokens",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "paymentToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "totalValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "requiredDeposit",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "postJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "metadataCid",
        type: "string",
      },
    ],
    name: "reportJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "reports",
    outputs: [
      {
        internalType: "address",
        name: "reporter",
        type: "address",
      },
      {
        internalType: "enum Job.States",
        name: "previousState",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "resolveDisputeForEngineer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
    ],
    name: "resolveDisputeForSupplier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "engineerAmountPct",
        type: "uint256",
      },
    ],
    name: "resolveDisputeWithCustomSplit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setDaoFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setDaoTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setJobTimeout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setMinBounty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setReportDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newPercent",
        type: "uint256",
      },
    ],
    name: "setReportReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "newToken",
        type: "address",
      },
    ],
    name: "setReportToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setResolutionFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "jobId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deposit",
        type: "uint256",
      },
    ],
    name: "startJob",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokensList",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
    ],
    name: "updatePaymentTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "0x60806040526802b5e3af16b18800006001556802b5e3af16b18800006002556103e860035561025860045562093a806005556802b5e3af16b18800006006556103e86008553480156200005157600080fd5b5060405162003d8f38038062003d8f833981016040819052620000749162000180565b6200007f3362000117565b6001600160a01b039283166000818152600b60205260408120805460ff19166001908117909155600c805491820181559091527fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c70180546001600160a01b031990811683179091556007805482169092179091556009805493851693821693909317909255600a8054919093169116179055620001d4565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6001600160a01b03811681146200017d57600080fd5b50565b6000806000606084860312156200019657600080fd5b8351620001a38162000167565b6020850151909350620001b68162000167565b6040850151909250620001c98162000167565b809150509250925092565b613bab80620001e46000396000f3fe6080604052600436106102f65760003560e01c806360eba8d81161018f578063b14a25a8116100e1578063d93d9beb1161008a578063f2fde38b11610064578063f2fde38b14610966578063f5a3f4af14610986578063fd2d5006146109a657600080fd5b8063d93d9beb1461091a578063e9e6a3491461093a578063f19451d81461095057600080fd5b8063c4f4775e116100bb578063c4f4775e14610894578063c8e627bf146108b4578063c942adf7146108ca57600080fd5b8063b14a25a814610814578063c3a3abb514610834578063c3b88b421461085457600080fd5b80638da5cb5b11610143578063a1c0d32f1161011d578063a1c0d32f146107b4578063aea4a803146107d4578063b05ea1ef146107f457600080fd5b80638da5cb5b14610760578063981f45fb1461077e578063a124df5d1461079457600080fd5b8063715018a611610174578063715018a6146106f0578063746ed2171461070557806379022a9f1461074057600080fd5b806360eba8d81461069b57806362503a2d146106d057600080fd5b8063328a39e9116102485780634bd23b9e116101fc5780634e543b26116101d65780634e543b261461063b5780635623a1ec1461065b5780636012ae831461067b57600080fd5b80634bd23b9e146105e55780634c5d8a0f146106055780634d12e34e1461061b57600080fd5b80633b58f49a1161022d5780633b58f49a1461058357806347d03162146105a3578063493eea6b146105c557600080fd5b8063328a39e9146105435780633afd86661461056357600080fd5b80631dffa3dc116102aa57806323c75e051161028457806323c75e05146104f7578063319f850c1461050d578063323095d91461052357600080fd5b80631dffa3dc146104975780631e01abca146104b7578063218cbcf0146104d757600080fd5b8063159b305e116102db578063159b305e14610398578063180aedf3146103d057806319fad10d1461047757600080fd5b80630880a2bf1461034d5780630b5ce6bb1461037657600080fd5b366103485760405162461bcd60e51b815260206004820152601960248201527f4e617469766520746f6b656e206e6f742061636365707465640000000000000060448201526064015b60405180910390fd5b600080fd5b34801561035957600080fd5b5061036360085481565b6040519081526020015b60405180910390f35b34801561038257600080fd5b5061039661039136600461368e565b6109c6565b005b3480156103a457600080fd5b506007546103b8906001600160a01b031681565b6040516001600160a01b03909116815260200161036d565b3480156103dc57600080fd5b5061045f6103eb36600461368e565b600e6020526000908152604090208054600182015460028301546003840154600485015460058601546006870154600788015460089098015460ff808916996101008a04821699620100008104909216986001600160a01b036301000000909304831698908316979216959194919391928c565b60405161036d9c9b9a999897969594939291906136df565b34801561048357600080fd5b50610396610492366004613750565b610b3b565b3480156104a357600080fd5b506103966104b236600461368e565b610d13565b3480156104c357600080fd5b506103966104d236600461368e565b610f3e565b3480156104e357600080fd5b506103966104f236600461368e565b6111b7565b34801561050357600080fd5b5061036360065481565b34801561051957600080fd5b5061036360045481565b34801561052f57600080fd5b5061039661053e36600461368e565b61124a565b34801561054f57600080fd5b5061039661055e366004613750565b6112dd565b34801561056f57600080fd5b5061039661057e366004613795565b6115ac565b34801561058f57600080fd5b5061039661059e36600461368e565b61172f565b3480156105af57600080fd5b506105b861177c565b60405161036d91906137ce565b3480156105d157600080fd5b506103966105e036600461381b565b611844565b3480156105f157600080fd5b5061039661060036600461368e565b6118ae565b34801561061157600080fd5b50610363600d5481565b34801561062757600080fd5b506103b861063636600461368e565b611a50565b34801561064757600080fd5b5061039661065636600461381b565b611a7a565b34801561066757600080fd5b506103966106763660046138db565b611ae4565b34801561068757600080fd5b5061039661069636600461368e565b611c4a565b3480156106a757600080fd5b506106bb6106b636600461368e565b611e6b565b6040805192835260208301919091520161036d565b3480156106dc57600080fd5b506103966106eb36600461368e565b611e9f565b3480156106fc57600080fd5b50610396612008565b34801561071157600080fd5b5061072561072036600461368e565b61205c565b6040805193845260208401929092529082015260600161036d565b34801561074c57600080fd5b506009546103b8906001600160a01b031681565b34801561076c57600080fd5b506000546001600160a01b03166103b8565b34801561078a57600080fd5b5061036360055481565b3480156107a057600080fd5b506103966107af36600461381b565b6120b4565b3480156107c057600080fd5b506103966107cf36600461368e565b61211e565b3480156107e057600080fd5b506103966107ef3660046138db565b612259565b34801561080057600080fd5b5061039661080f36600461368e565b6124f0565b34801561082057600080fd5b5061039661082f36600461368e565b61258a565b34801561084057600080fd5b5061039661084f3660046138db565b61261d565b34801561086057600080fd5b5061088461086f36600461381b565b600b6020526000908152604090205460ff1681565b604051901515815260200161036d565b3480156108a057600080fd5b506103966108af366004613922565b612879565b3480156108c057600080fd5b5061036360015481565b3480156108d657600080fd5b5061090c6108e536600461368e565b600f602052600090815260409020546001600160a01b03811690600160a01b900460ff1682565b60405161036d929190613985565b34801561092657600080fd5b5061039661093536600461368e565b612ab2565b34801561094657600080fd5b5061036360035481565b34801561095c57600080fd5b5061036360025481565b34801561097257600080fd5b5061039661098136600461381b565b612c19565b34801561099257600080fd5b50600a546103b8906001600160a01b031681565b3480156109b257600080fd5b506103966109c136600461368e565b612ce9565b600a546001600160a01b03163314610a135760405162461bcd60e51b815260206004820152601060248201526f4e6f7420417574686f72697a6564202160801b604482015260640161033f565b806004806000838152600e602052604090205462010000900460ff16600d811115610a4057610a406136a7565b14610a865760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600e60205260408120805462ff00001916620b0000178155600581015460068201546004909201548392610abf9291612dd0565b6000878152600e602052604090206002810154600190910154929450909250610af8916001600160a01b03918216918591859116612e1d565b847f939d72eb56b6f23f7b97e72ca719888f5088a42eee0af0bc7147d53b48b14728612710604051610b2c91815260200190565b60405180910390a25050505050565b816001806000838152600e602052604090205462010000900460ff16600d811115610b6857610b686136a7565b14610bae5760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000848152600e6020526040902060030154831015610c0f5760405162461bcd60e51b815260206004820152601c60248201527f4d696e696d756d207061796d656e74206e6f742070726f766964656400000000604482015260640161033f565b6000848152600e6020526040902054630100000090046001600160a01b0316331415610c7d5760405162461bcd60e51b815260206004820152601d60248201527f41646472657373206d6179206e6f74206265206a6f6220706f73746572000000604482015260640161033f565b6000848152600e6020526040902060020154610ca3906001600160a01b03163385612e40565b6000848152600e60205260408082206001810180546001600160a01b0319163390811790915560048201879055426007830155815462ff000019166202000017909155905186927f02b831748dc31071eb5a29824154004c51df36269620ebd3e7b33e1a9980d68491a350505050565b6000818152600e60205260409020548190630100000090046001600160a01b03163314610d8e5760405162461bcd60e51b8152602060048201526024808201527f4d6574686f64206e6f7420617661696c61626c6520666f722074686973206361604482015263363632b960e11b606482015260840161033f565b816001806000838152600e602052604090205462010000900460ff16600d811115610dbb57610dbb6136a7565b14610e015760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000848152600e60209081526040808320815161018081018352815460ff8082161515835261010082048116151595830195909552909391928401916201000090910416600d811115610e5657610e566136a7565b600d811115610e6757610e676136a7565b815281546001600160a01b0363010000009091048116602080840191909152600184015482166040808501919091526002850154909216606084015260038401546080840152600484015460a0840152600584015460c0840152600684015460e08401526007840154610100840152600890930154610120909201919091526000888152600e9092529020805462ff00001916620700001790559050610f0c81612e5a565b60405185907f68a66a704ceacc38da3f12c63779e47866d9d72e875ec5d43237777adc666d6590600090a25050505050565b806002806000838152600e602052604090205462010000900460ff16600d811115610f6b57610f6b6136a7565b14610fb15760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600e60209081526040808320815161018081018352815460ff8082161515835261010082048116151595830195909552909391928401916201000090910416600d811115611006576110066136a7565b600d811115611017576110176136a7565b81528154630100000090046001600160a01b0390811660208301526001830154811660408301526002830154811660608084019190915260038401546080840152600484015460a0840152600584015460c0840152600684015460e084015260078401546101008401526008909301546101209092019190915290820151919250163314156110ae576110a984612e9e565b611129565b80608001516001600160a01b0316336001600160a01b031614156110d5576110a984612f40565b60405162461bcd60e51b8152602060048201526024808201527f4d6574686f64206e6f7420617661696c61626c6520666f722074686973206361604482015263363632b960e11b606482015260840161033f565b6000848152600e602052604090205460ff16801561115a57506000848152600e6020526040902054610100900460ff165b156111b1576000848152600e60205260409020805462ff000019166208000017905561118581612e5a565b60405184907f6edf0875f8a9ed26275e4e52f2355d96ea7fd96625d6992a9733be603136fa6e90600090a25b50505050565b6000546001600160a01b031633146111ff5760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b6109c48111156112455760405162461bcd60e51b81526020600482015260116024820152700acc2d8eaca40d2e640e8dede40d0d2ced607b1b604482015260640161033f565b600855565b6000546001600160a01b031633146112925760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b6109c48111156112d85760405162461bcd60e51b81526020600482015260116024820152700acc2d8eaca40d2e640e8dede40d0d2ced607b1b604482015260640161033f565b600455565b600a546001600160a01b0316331461132a5760405162461bcd60e51b815260206004820152601060248201526f4e6f7420417574686f72697a6564202160801b604482015260640161033f565b816004806000838152600e602052604090205462010000900460ff16600d811115611357576113576136a7565b1461139d5760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b60648310156113ee5760405162461bcd60e51b815260206004820152601260248201527f50657263656e7461676520746f6f206c6f770000000000000000000000000000604482015260640161033f565b6113fb60646127106139b8565b83111561144a5760405162461bcd60e51b815260206004820152601360248201527f50657263656e7461676520746f6f206869676800000000000000000000000000604482015260640161033f565b6000848152600e602090815260408083208054620c000062ff00001982161780835583516101808101855260ff9283161515815261010082048316151595810195909552919284019162010000900416600d8111156114ab576114ab6136a7565b600d8111156114bc576114bc6136a7565b815281546001600160a01b03630100000090910481166020830152600183015481166040830152600283015416606082015260038201546080820152600482015460a0820152600582015460c0820152600682015460e0808301919091526007830154610100808401919091526008909301546101209283015291830151918301519083015192935060009283928392611556928a612fe9565b92509250925061156884848484613070565b877f939d72eb56b6f23f7b97e72ca719888f5088a42eee0af0bc7147d53b48b147288860405161159a91815260200190565b60405180910390a25050505050505050565b6000546001600160a01b031633146115f45760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b80158061161f57506001600160a01b0382166000908152600b602052604090205460ff161515600114155b61166b5760405162461bcd60e51b815260206004820152600f60248201527f416c726561647920616464656420210000000000000000000000000000000000604482015260640161033f565b6001600160a01b0382166000908152600b60205260409020805460ff191682158015919091179091556116e857600c80546001810182556000919091527fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c70180546001600160a01b0319166001600160a01b0384161790556116f3565b6116f1826130b2565b505b604051811515906001600160a01b038416907feb76470ecb1246037d7483775e7c72dd83f8613c83a6a2949027bf0dcc9e8b3b90600090a35050565b6000546001600160a01b031633146117775760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b600155565b600c546060908067ffffffffffffffff81111561179b5761179b613838565b6040519080825280602002602001820160405280156117c4578160200160208202803683370190505b50915060005b8181101561183f57600c81815481106117e5576117e56139cf565b9060005260206000200160009054906101000a90046001600160a01b0316838281518110611815576118156139cf565b6001600160a01b039092166020928302919091019091015280611837816139e5565b9150506117ca565b505090565b6000546001600160a01b0316331461188c5760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b600780546001600160a01b0319166001600160a01b0392909216919091179055565b806003806000838152600e602052604090205462010000900460ff16600d8111156118db576118db6136a7565b146119215760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600e60205260409020548390630100000090046001600160a01b0316331461199c5760405162461bcd60e51b8152602060048201526024808201527f4d6574686f64206e6f7420617661696c61626c6520666f722074686973206361604482015263363632b960e11b606482015260840161033f565b6000848152600e60205260408120805462ff00001916620600001781556005810154600682015460049092015483926119d59291613269565b6000888152600e602052604090206002810154600190910154929450909250611a0e916001600160a01b03918216918591859116612e1d565b857f72a8659d664e8c3afdc18cf46adfba3acd130a459e0658ed768a45b08c08362083604051611a4091815260200190565b60405180910390a2505050505050565b600c8181548110611a6057600080fd5b6000918252602090912001546001600160a01b0316905081565b6000546001600160a01b03163314611ac25760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b600a80546001600160a01b0319166001600160a01b0392909216919091179055565b600a546001600160a01b03163314611b315760405162461bcd60e51b815260206004820152601060248201526f4e6f7420417574686f72697a6564202160801b604482015260640161033f565b816005806000838152600e602052604090205462010000900460ff16600d811115611b5e57611b5e6136a7565b14611ba45760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000848152600f6020908152604080832054600e90925290912080546001600160a01b03831692600160a01b900460ff16919062ff000019166201000083600d811115611bf357611bf36136a7565b0217905550600754600954600654611c18926001600160a01b03908116921690613280565b847fab7c6483dabf33f55ec54b2ab25b9c9b74082a4b8c4427478613be8f4e6ba49a8286604051610b2c929190613a58565b806003806000838152600e602052604090205462010000900460ff16600d811115611c7757611c776136a7565b14611cbd5760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600e602052604090206001015483906001600160a01b03163314611d345760405162461bcd60e51b8152602060048201526024808201527f4d6574686f64206e6f7420617661696c61626c6520666f722074686973206361604482015263363632b960e11b606482015260840161033f565b6005546000858152600e6020526040902060080154611d5390426139b8565b1015611dc75760405162461bcd60e51b815260206004820152602160248201527f4a6f62207374696c6c20696e20617070726f76616c2074696d652077696e646f60448201527f7700000000000000000000000000000000000000000000000000000000000000606482015260840161033f565b6000848152600e60205260408120805462ff0000191662090000178155600581015460068201546004909201548392611e009291613269565b6000888152600e602052604090206002810154600190910154929450909250611e39916001600160a01b03918216918591859116612e1d565b857faf230594829c3ee2a7149591bfbacac94abd4b4f3f3d952ffe1e4139fa1a250383604051611a4091815260200190565b6000818152600e60205260408120600581015460068201546004909201548392611e959291612dd0565b9094909350915050565b600a546001600160a01b03163314611eec5760405162461bcd60e51b815260206004820152601060248201526f4e6f7420417574686f72697a6564202160801b604482015260640161033f565b806004806000838152600e602052604090205462010000900460ff16600d811115611f1957611f196136a7565b14611f5f5760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600e60205260408120805462ff00001916620a0000178155600581015460068201546004909201548392611f989291612dd0565b6000878152600e6020526040902060028101549054929450909250611fd5916001600160a01b039182169185918591630100000090910416612e1d565b847f939d72eb56b6f23f7b97e72ca719888f5088a42eee0af0bc7147d53b48b147286000604051610b2c91815260200190565b6000546001600160a01b031633146120505760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b61205a6000613294565b565b6000818152600e60205260408120600581015460068201546004909201548392839261208a92909190613269565b6000868152600e602052604090206004015491945091506120ab90846139b8565b91509193909250565b6000546001600160a01b031633146120fc5760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b600980546001600160a01b0319166001600160a01b0392909216919091179055565b806002806000838152600e602052604090205462010000900460ff16600d81111561214b5761214b6136a7565b146121915760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600e602052604090206001015483906001600160a01b031633146122085760405162461bcd60e51b8152602060048201526024808201527f4d6574686f64206e6f7420617661696c61626c6520666f722074686973206361604482015263363632b960e11b606482015260840161033f565b6000848152600e6020526040808220805462ff0000191662030000178155426008909101555185917f02244c8529cb95e213ee542e76e7776342b3dabd10203d01472bbf4441be892991a250505050565b600a546001600160a01b031633146122a65760405162461bcd60e51b815260206004820152601060248201526f4e6f7420417574686f72697a6564202160801b604482015260640161033f565b816005806000838152600e602052604090205462010000900460ff16600d8111156122d3576122d36136a7565b146123195760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000848152600e60209081526040808320815161018081018352815460ff8082161515835261010082048116151595830195909552909391928401916201000090910416600d81111561236e5761236e6136a7565b600d81111561237f5761237f6136a7565b815281546001600160a01b03630100000090910481166020808401919091526001840154821660408085019190915260028501548316606085015260038501546080850152600485015460a0850152600585015460c0850152600685015460e08501526007850154610100808601919091526008958601546101209095019490945260008b8152600f835281812054600e909352908120805462ff00001916620d000017905593549285015194955016926127109161243d91613a7a565b6124479190613a99565b90506000818461012001518561010001516124629190613abb565b61246c91906139b8565b905061248a8460a0015184846006546124859190613abb565b613280565b61249d8460a00151856060015183613280565b60e0840151156124be576124be8460a0015185608001518660e00151613280565b877f148b8a7406b4adcbc94e8e6c407fe673caf6278408045e0b848eb204c5f0876b848960405161159a929190613a58565b6000546001600160a01b031633146125385760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b680ad78ebc5ac62000008111156125855760405162461bcd60e51b81526020600482015260116024820152700acc2d8eaca40d2e640e8dede40d0d2ced607b1b604482015260640161033f565b600655565b6000546001600160a01b031633146125d25760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b6109c48111156126185760405162461bcd60e51b81526020600482015260116024820152700acc2d8eaca40d2e640e8dede40d0d2ced607b1b604482015260640161033f565b600355565b6000828152600e60209081526040808320815161018081018352815460ff8082161515835261010082048116151595830195909552909391928401916201000090910416600d811115612672576126726136a7565b600d811115612683576126836136a7565b815281546001600160a01b03630100000090910481166020830152600180840154821660408401526002840154909116606083015260038301546080830152600483015460a0830152600583015460c0830152600683015460e08301526007830154610100830152600890920154610120909101529091508160400151600d811115612711576127116136a7565b1480612732575060028160400151600d811115612730576127306136a7565b145b6127775760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000838152600f60205260409081902080546001600160a01b0319811633908117835592840151927fffffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffff167fffffffffffffffffffffff00000000000000000000000000000000000000000090911617600160a01b83600d8111156127fd576127fd6136a7565b02179055506000838152600e60205260409020805462ff000019166205000017905560075460065461283a916001600160a01b0316903390612e40565b827fe7e395be1d74b8b55bfc9e68cf18ac46d478801f42635847a1a536e03da49641338460405161286c929190613a58565b60405180910390a2505050565b6001600160a01b0384166000908152600b6020526040902054849060ff166128e35760405162461bcd60e51b815260206004820152601160248201527f4e6f742057686974656c69737465642021000000000000000000000000000000604482015260640161033f565b6002548310156129355760405162461bcd60e51b815260206004820152601c60248201527f4d696e696d756d206465706f736974206e6f742070726f766964656400000000604482015260640161033f565b600080612941866132e4565b915091506001548210156129975760405162461bcd60e51b815260206004820152601b60248201527f4d696e696d756d20626f756e7479206e6f742070726f76696465640000000000604482015260640161033f565b818511156129e75760405162461bcd60e51b815260206004820152601160248201527f4465706f73697420746f6f206c61726765000000000000000000000000000000604482015260640161033f565b6129f2873388612e40565b600d60008154612a01906139e5565b90915550600d546000818152600e60205260409081902080546002820180546001600160a01b0319166001600160a01b038d1617905560058201869055600682018590557fffffffffffffffffff000000000000000000000000000000000000000000ffff163363010000000262ff0000191617620100001781556003018790555181907f7949b39d704038fb84fd3c53f76b9c855172c9fa4f7463e0643b8bc0819e03759061159a908890613ad3565b6000818152600e60205260409020548190630100000090046001600160a01b03163314612b2d5760405162461bcd60e51b8152602060048201526024808201527f4d6574686f64206e6f7420617661696c61626c6520666f722074686973206361604482015263363632b960e11b606482015260840161033f565b60026000838152600e602052604090205462010000900460ff16600d811115612b5857612b586136a7565b1480612b8c575060036000838152600e602052604090205462010000900460ff16600d811115612b8a57612b8a6136a7565b145b612bd15760405162461bcd60e51b81526020600482015260226024820152600080516020613b36833981519152604482015261746560f01b606482015260840161033f565b6000828152600e6020526040808220805462ff00001916620400001790555183917fb1dee78cef8c6887046d91c59e17f84fbc012c9f7efa49a10cce97e13cc94bf491a25050565b6000546001600160a01b03163314612c615760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b6001600160a01b038116612cdd5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f6464726573730000000000000000000000000000000000000000000000000000606482015260840161033f565b612ce681613294565b50565b6000546001600160a01b03163314612d315760405162461bcd60e51b81526020600482018190526024820152600080516020613b56833981519152604482015260640161033f565b6203f480811015612d845760405162461bcd60e51b815260206004820152601060248201527f56616c756520697320746f6f206c6f7700000000000000000000000000000000604482015260640161033f565b62278d00811115612dcb5760405162461bcd60e51b81526020600482015260116024820152700acc2d8eaca40d2e640e8dede40d0d2ced607b1b604482015260640161033f565b600555565b60008080612dde8487613abb565b905061271060045482612df19190613a7a565b612dfb9190613a99565b915081612e088683613abb565b612e1291906139b8565b925050935093915050565b612e28848285613280565b6009546111b19085906001600160a01b031684613280565b612e556001600160a01b038416833084613320565b505050565b612e7d8160a0015182606001518361012001518461010001516124859190613abb565b60e081015115612ce657612ce68160a0015182608001518360e00151613280565b6000818152600e602052604090205460ff1615612efd5760405162461bcd60e51b815260206004820152601e60248201527f436c6f7365207265717565737420616c72656164792072656365697665640000604482015260640161033f565b6000818152600e6020526040808220805460ff191660011790555182917f23381fead13c37b4addfaef6bf8a32810dac28e3510d478620117cb6f68f7c7a91a250565b6000818152600e6020526040902054610100900460ff1615612fa45760405162461bcd60e51b815260206004820152601e60248201527f436c6f7365207265717565737420616c72656164792072656365697665640000604482015260640161033f565b6000818152600e6020526040808220805461ff0019166101001790555182917f1015d31993c4d152d1d9f3c6692c7fc8ab5dadc67eed74612c6286f6d98409ad91a250565b6000808080612ff88789613abb565b9050600086613007898b613abb565b6130119190613abb565b9050612710600454836130249190613a7a565b61302e9190613a99565b9250600061303c84836139b8565b905061271061304b8883613a7a565b6130559190613a99565b945061306185826139b8565b95505050509450945094915050565b6130838460a00151856060015185613280565b6130968460a00151856080015184613280565b60a08401516009546111b191906001600160a01b031683613280565b600c54600090806130c65750600092915050565b6001600160a01b038316600c6130dd6001846139b8565b815481106130ed576130ed6139cf565b6000918252602090912001546001600160a01b0316141561314457600c80548061311957613119613ae6565b600082815260209020810160001990810180546001600160a01b031916905501905550600192915050565b6000805b6131536001846139b8565b81101561322757846001600160a01b0316600c8281548110613177576131776139cf565b6000918252602090912001546001600160a01b0316141561319757600191505b811561321557600c6131aa826001613abb565b815481106131ba576131ba6139cf565b600091825260209091200154600c80546001600160a01b0390921691839081106131e6576131e66139cf565b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b031602179055505b8061321f816139e5565b915050613148565b50801561326257600c80548061323f5761323f613ae6565b600082815260209020810160001990810180546001600160a01b03191690550190555b9392505050565b6000826132768386613abb565b9150935093915050565b612e556001600160a01b03841683836133d1565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6000806003546127106132f79190613abb565b61330384612710613a7a565b61330d9190613a99565b915061331982846139b8565b9050915091565b6040516001600160a01b03808516602483015283166044820152606481018290526111b19085907f23b872dd00000000000000000000000000000000000000000000000000000000906084015b60408051601f198184030181529190526020810180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff167fffffffff000000000000000000000000000000000000000000000000000000009093169290921790915261341a565b6040516001600160a01b038316602482015260448101829052612e559084907fa9059cbb000000000000000000000000000000000000000000000000000000009060640161336d565b600061346f826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166134ff9092919063ffffffff16565b805190915015612e55578080602001905181019061348d9190613afc565b612e555760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e60448201527f6f74207375636365656400000000000000000000000000000000000000000000606482015260840161033f565b606061350e8484600085613516565b949350505050565b60608247101561358e5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f60448201527f722063616c6c0000000000000000000000000000000000000000000000000000606482015260840161033f565b843b6135dc5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604482015260640161033f565b600080866001600160a01b031685876040516135f89190613b19565b60006040518083038185875af1925050503d8060008114613635576040519150601f19603f3d011682016040523d82523d6000602084013e61363a565b606091505b509150915061364a828286613655565b979650505050505050565b60608315613664575081613262565b8251156136745782518084602001fd5b8160405162461bcd60e51b815260040161033f9190613ad3565b6000602082840312156136a057600080fd5b5035919050565b634e487b7160e01b600052602160045260246000fd5b600e81106136db57634e487b7160e01b600052602160045260246000fd5b9052565b8c151581528b1515602082015261018081016136fe604083018d6136bd565b6001600160a01b039a8b166060830152988a1660808201529690981660a087015260c086019490945260e085019290925261010084015261012083015261014082015261016001919091529392505050565b6000806040838503121561376357600080fd5b50508035926020909101359150565b6001600160a01b0381168114612ce657600080fd5b8015158114612ce657600080fd5b600080604083850312156137a857600080fd5b82356137b381613772565b915060208301356137c381613787565b809150509250929050565b6020808252825182820181905260009190848201906040850190845b8181101561380f5783516001600160a01b0316835292840192918401916001016137ea565b50909695505050505050565b60006020828403121561382d57600080fd5b813561326281613772565b634e487b7160e01b600052604160045260246000fd5b600082601f83011261385f57600080fd5b813567ffffffffffffffff8082111561387a5761387a613838565b604051601f8301601f19908116603f011681019082821181831017156138a2576138a2613838565b816040528381528660208588010111156138bb57600080fd5b836020870160208301376000602085830101528094505050505092915050565b600080604083850312156138ee57600080fd5b82359150602083013567ffffffffffffffff81111561390c57600080fd5b6139188582860161384e565b9150509250929050565b6000806000806080858703121561393857600080fd5b843561394381613772565b93506020850135925060408501359150606085013567ffffffffffffffff81111561396d57600080fd5b6139798782880161384e565b91505092959194509250565b6001600160a01b03831681526040810161326260208301846136bd565b634e487b7160e01b600052601160045260246000fd5b6000828210156139ca576139ca6139a2565b500390565b634e487b7160e01b600052603260045260246000fd5b60006000198214156139f9576139f96139a2565b5060010190565b60005b83811015613a1b578181015183820152602001613a03565b838111156111b15750506000910152565b60008151808452613a44816020860160208601613a00565b601f01601f19169290920160200192915050565b6001600160a01b038316815260406020820152600061350e6040830184613a2c565b6000816000190483118215151615613a9457613a946139a2565b500290565b600082613ab657634e487b7160e01b600052601260045260246000fd5b500490565b60008219821115613ace57613ace6139a2565b500190565b6020815260006132626020830184613a2c565b634e487b7160e01b600052603160045260246000fd5b600060208284031215613b0e57600080fd5b815161326281613787565b60008251613b2b818460208701613a00565b919091019291505056fe4d6574686f64206e6f7420617661696c61626c6520666f72206a6f62207374614f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572a264697066735822122055d44765855a5c865077cf9ce02c09985c7fc4703a22a897b4f78e0b575ad2a564736f6c63430008090033";

export class Job__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _initialToken: string,
    _daoTreasury: string,
    _resolver: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Job> {
    return super.deploy(
      _initialToken,
      _daoTreasury,
      _resolver,
      overrides || {}
    ) as Promise<Job>;
  }
  getDeployTransaction(
    _initialToken: string,
    _daoTreasury: string,
    _resolver: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _initialToken,
      _daoTreasury,
      _resolver,
      overrides || {}
    );
  }
  attach(address: string): Job {
    return super.attach(address) as Job;
  }
  connect(signer: Signer): Job__factory {
    return super.connect(signer) as Job__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): JobInterface {
    return new utils.Interface(_abi) as JobInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Job {
    return new Contract(address, _abi, signerOrProvider) as Job;
  }
}
